<template>
    <div class="layout-dialog relative z-8000" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div class="fixed inset-0 bg-zinc-900/75 transition-opacity"></div>
        <div class="fixed inset-0 z-8000 w-screen overflow-y-auto">
            <div class="flex min-h-full items-center justify-center p-4 sm:p-0">
                <div
                    class="relative transform overflow-hidden rounded-lg bg-zinc-50 px-4 pb-4 pt-5 text-left shadow-xl transition-all w-full sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
                >
                    <div>
                        <h3
                            class="text-2xl mb-5 pr-4 font-semibold leading-10 tracking-tight text-zinc-800"
                            id="modal-title"
                            :class="!!$slots.content ? 'mb-3' : ''"
                            v-if="title"
                        >
                            {{ title }}
                        </h3>
                        <div class="text-zinc-700 font-medium" v-if="!!$slots.content">
                            <slot name="content"></slot>
                        </div>
                    </div>
                    <div class="mt-5 flex flex-row sm:mt-6" v-if="!!$slots.buttons">
                        <slot name="buttons"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LayoutDialog',
    props: {
        title: {
            required: false,
            type: String,
            default: null,
        },
    },
};
</script>
